import { ProjectCard } from "./ProjectCard";
import { Reveal } from "./Reveal";

const ASPECTS = ["aspect-[4/5]", "aspect-[3/4]", "aspect-square", "aspect-[4/5]", "aspect-[5/4]", "aspect-[3/4]"];

export const ProjectGrid = ({ projects, testid = "project-grid" }) => {
  const left = projects.filter((_, i) => i % 2 === 0);
  const right = projects.filter((_, i) => i % 2 === 1);
  const col = (items, offset) =>
    items.map((p, i) => {
      const idx = i * 2 + offset;
      return (
        <Reveal key={p.id || p.slug} delay={offset * 0.12}>
          <ProjectCard project={p} index={idx} aspect={ASPECTS[idx % ASPECTS.length]} />
        </Reveal>
      );
    });
  if (projects.length === 1) {
    return (
      <div data-testid={testid} className="mx-auto max-w-2xl">
        <ProjectCard project={projects[0]} aspect="aspect-[4/5]" />
      </div>
    );
  }
  return (
    <div data-testid={testid} className="grid gap-16 md:grid-cols-12 md:gap-x-10">
      <div className="flex flex-col gap-16 md:col-span-6 md:gap-24">{col(left, 0)}</div>
      <div className="flex flex-col gap-16 md:col-span-5 md:col-start-8 md:mt-40 md:gap-24">{col(right, 1)}</div>
    </div>
  );
};
